export const truncateName = (text, maxLength = 10) => {
    if (!text)
        return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};
